export const environment = {
	project: "KZ",
	production: true,
	id: "d1082d84-a0fc-402d-9565-7de4c571072d"
};
